module.exports = __webpack_public_path__ + "media/images/application/icons/like-empty-bd23da713073c3b3b665e0009eabf032.svg";